<template>
  <el-container class="legacy-site-shell">
    <div class="modal">
    </div>
    <site-header v-if="showHeader" />
    <center v-if="false">
      <el-header v-if="showHeader" class="el-header-index">
        <div style="float: left;margin-top: 20px;">
          <img class="img" src="../assets/img/logo-big.png" alt="" data-track-text="首页Logo" aria-label="首页Logo" style="cursor: pointer" @click="toIndex">
        </div>
        <div style="float: right;">
          <el-menu v-show="this.$route.path!=='/agreement'" :class="'el-menu-index'"
                   :active-text-color="'#184687'"
                   :text-color="'black'"
                   :default-active="this.$route.name==='DocView'?(isShowTransPro?'/':'/'):this.$route.path"
                   mode="horizontal"
                   @select="handleSelect">
            <el-menu-item :class="'el-menu-item-index'"
                          index="/index">首页
            </el-menu-item>
            <el-menu-item :class="'el-menu-item-index'"
                          index="/translate">
              立即翻译
            </el-menu-item>
            <el-menu-item v-show="isShowTransPro" :class="'el-menu-item-index'"
                          index="/translate-pro">
              人工翻译
            </el-menu-item>
            <el-menu-item :class="'el-menu-item-index'"
                          index="/convert">pdf转换
            </el-menu-item>
            <el-menu-item :class="'el-menu-item-indexs'"
                          :index="isShowTransPro?'/list-pro':'/list'">历史文档
            </el-menu-item>
            <el-menu-item class="user-right" style="margin-left: 30px;" index="/help">
              <i class="custome-icon el-icon-question"></i>
              <span style="padding-left: 8px;width: 27px;
            height: 15px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            ">帮助</span>
            </el-menu-item>
            <el-menu-item class="user-right">
                            <span class="el-dropdown-link" v-if="!showloginOut">
                              <span
                                  style="
                                    font-size: 14px;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    display: inline-block;
                                    width: 86px;
                                    overflow: hidden;
                                    margin-right: 14px;
                                    height: 36px;
                                    background: #f5f5f500;
                                    border: 1px solid #184687;
                                    border-radius: 3px;
                                    line-height: 2.5;
                                    text-align: center;
                                    font-family: Microsoft YaHei;
                                    font-weight: 400;
                                    color: #184687;" data-track-text="登录注册入口" aria-label="登录注册入口" @click="showIframe('/login')">{{ userInfo }}</span>
                            </span>
              <el-dropdown @command="logOut" v-if="showloginOut">
                                <span class="el-dropdown-link">
                                  <span :style="'color:black'"
                                        <span :style="'color:black'"
                                              style="
                                        font-size: 14px;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        display: inline-block;
                                        max-width: 150px;
                                        overflow: hidden;
                                        margin-right: 14px;" :title="userInfo">{{ userInfo }}</span>
                                </span>
                <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                  <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">个人中心
                  </el-dropdown-item>
                  <el-dropdown-item style="z-index: 1;font-weight: 800">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
            <el-menu-item class="submenuslogin" v-show="groupUserInfo==='机构登录'">
                        <span :style="'color:black'"
                              style="
                                  font-size: 14px;
                                  color: black;
                                  text-overflow: ellipsis;
                                  white-space: nowrap;
                                  display: inline-block;
                                  width: 100%;
                                  overflow: hidden;" v-if="groupUserInfo==='机构登录'"
                                  data-track-text="机构登录入口" aria-label="机构登录入口" @click="showIframe('/login')">{{ groupUserInfo }}</span>
            </el-menu-item>
            <el-submenu class="submenus" index="2" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'">
              <template slot="title">
                              <span :style="'color:black'"
                                    style="
                                      font-size: 14px;
                                      color: black;
                                      text-overflow: ellipsis;
                                      white-space: nowrap;
                                      display: inline-block;
                                      width: 100%;
                                      overflow: hidden;" :title="groupUserInfo">{{ groupUserInfo }}</span>
              </template>
              <el-menu-item v-for="(item,index) in groupUserInfos" :key="index">{{ item.name }}<span
                  v-if="!item.isIpScore" style="float: right;font-weight: 800"><a
                  data-track-text="退出机构账号" aria-label="退出机构账号" @click="logOut(item.name)">退出</a></span>
              </el-menu-item>
              <el-menu-item data-track-text="登录机构账号" aria-label="登录机构账号" @click="showIframe('/login')">登录机构账号</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-header>
    </center>
    <center>
      <div class="el-mains">
        <router-view></router-view>
        <el-footer v-if="false" :class="'footer'">
          <span>© 2020&nbsp;北京容智科技发展有限公司</span>
          <span>&nbsp;&nbsp;&nbsp;京ICP备19036872号-3  All rights reserved.&nbsp;&nbsp;&nbsp;</span>
          <img src="../assets/download.png" alt="" style="transform: translate(1px, 3px);">
          <span>&nbsp;&nbsp;京公网安备&nbsp;11011402010815号</span>
          <span style="margin-left: 15px">联系电话：010-80755328</span>
        </el-footer>
        <site-footer v-if="this.$route.name!=='DocView'" />
      </div>
    </center>
    <floating-contact-tools v-show="this.$route.name!=='DocView'" />
    <el-dialog
        :lock-scroll="false"
        custom-class="payTipClass"
        :show-close="false"
        :visible.sync="payCenterDialogVisible"
        width="308px"
        center>
      <span slot="footer" class="dialog-footer">
        <div class="el-div" data-track-text="暂不开通漫游" aria-label="暂不开通漫游" @click="noRead" style="    color: rgb(153, 153, 153);
      width: 140px;
      border-right: 1px solid rgb(204, 204, 204);
      position: absolute;">暂不</div>
        <div class="el-div" data-track-text="了解开通漫游" aria-label="了解开通漫游" @click="toRead" style="     color: rgb(24, 70, 135);
      width: 150px;
      position: absolute;
      left: 160px;
  }">马上了解</div>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  thirdLoginRequest,
  authServiceClient,
  userStatusRequest,
  outRequest,
  userPowerRequest
} from "../tools/api/auth-api";
import {translateServiceClient} from "@/tools/api/service";
import {uploadTipRequest} from "@/tools/api/translate-api";
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";
import FloatingContactTools from "@/components/home/FloatingContactTools.vue";

export default {
  components: { SiteHeader, SiteFooter, FloatingContactTools },
  name: "Index",
  data() {
    return {
      isShowTransPro: false,
      isShowInRoaming: false,
      payCenterDialogVisible: false,
      groupUserInfos: [],
      url: '/login',
      activeIndex: '1',
      userInfo: '登录/注册',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: ''
    }
  },
  created() {
    this.getUploadTip()
    const that = this;
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "登录/注册";
        this.groupUserInfo = "";
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.userInfo = realName
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "登录/注册";
      that.showTip()
    });
  },
  mounted() {
    const code = this.getUrlParameter(this.$route.fullPath).code;
    const state = this.getUrlParameter(this.$route.fullPath).state;
    if (code !== undefined && code !== null && code !== "") {
      this.checkLogin(code, state);
      return
    }
  },
  methods: {
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code)
      request.setState(state)
      const TOKEN_KEY = 'token';
      authServiceClient.thirdLogin(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let status = res.getStatus();
        if (status === "400") {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          setTimeout(this.toNew, 3000);
          return;
        }
        if (status === "201") {
          let openid = res.getOpenid();
          let type = res.getType();
          this.$router.push({
            name: "Bind",
            params: {openid: openid, type: type}
          })
          return;
        }
        if (status === "200") {
          this.$router.push("/index")
          window.location.reload()
          return;
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "登录失败请重试"
        });
      })
    },
    toNew() {
      window.open("https://wesitrans.com", "_self")
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    showTip() {
      const tip = sessionStorage.getItem("payTip");
      if (this.$route.path === "/" || this.$route.path === "/index") {
        if (tip === undefined || tip === null || tip === "") {
          this.payCenterDialogVisible = true;
        }
      }
    },
    noRead() {
      this.payCenterDialogVisible = false
      sessionStorage.setItem("payTip", "ok");
    },
    toRead() {
      this.payCenterDialogVisible = false
      sessionStorage.setItem("payTip", "ok");
      this.$router.push("/payTip")
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      }
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    toIndex() {
      this.$router.push('/index');
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "登录/注册";
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    },
    showIframe(url) {
      return this.$authPopup.open(url, { area: ['948px', '501px'] })
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowInRoaming = res.getIsRoaming();
        this.isShowTransPro = res.getIsTransPro();
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
      });
    },
    handleSelect(key) {
      if(key==='/translate-pro'){
        window.open("/trans-pro/index", "_self")
        return;
      }
      this.url = process.env.VUE_APP_WEB_LOGIN_URL;
      if (key == null) return;
      const TOKEN_KEY = 'token';
      authServiceClient.getUserStatus(userStatusRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (key === "/index" || key === "/help" || key === "/translate" || key === "/convert") {
          this.$router.push(key)
          return;
        }
        if (!res.getStatus()) {
          localStorage.removeItem("token")
          localStorage.removeItem("auth-context")
          this.userInfo = "登录/注册";
          this.$router.push("/index")
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          return;
        }
        if (localStorage.getItem('auth-context') &&
            localStorage.getItem('token')) {
          authServiceClient.checkUserPower(userPowerRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (res.getStatus()) {
              this.$router.push(key);
              return;
            }
            this.$message({
              center: true,
              type: 'error',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }).catch(err => {
            if (key === "/index" || key === "/help") {
              this.$router.push(key)
              return;
            }
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            this.userInfo = "登录/注册";
            this.$router.push("/index")
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          })
        } else {
          this.userInfo = "登录/注册";
          this.$router.push("/index")
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        }
      }).catch(err => {
        if (key === "/index" || key === "/help" || key === "/translate" || key === "/convert") {
          this.$router.push(key)
          return;
        }
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "登录/注册";
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    }
  },
}
</script>

<style lang="less" scoped>
.legacy-site-shell {
  min-height: 100vh;
  display: flex !important;
  flex-direction: column;
}

.legacy-site-shell > center {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  width: 100%;
}

.icon-help::after {
  content: '？';
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  transform: translate(3px, 0px);
}

.icon-help {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  background-color: #666666;
  border-radius: 50%;
  margin-right: 5px;
  transform: translate(0px, 0px);
}

/deep/ .payTipClass {
  margin-top: 20vh !important;
  border-radius: 5%;
  width: 308px !important;

  .el-dialog__header {
    display: none
  }

  .el-dialog__body {
    margin: 0;
    padding: 0;
    height: 513px;
    background: url(../assets/zhifutip.png) no-repeat;
    background-size: 100%;
    width: 308px;
    height: 233px;
  }

  .el-dialog__footer {
    height: 54px;

    .dialog-footer {
      line-height: 1.5;

      .el-div {
        cursor: pointer;
        border: 0 solid;
        height: 34px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-align: center;
      }
    }
  }
}

.backClass {
  text-align: center;
  width: 68px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.25);
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
}
.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}
.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-top: 0;
}

/deep/ .nonemenu:hover {
  display: none !important;
  height: 0 !important;
  z-index: -1 !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 3px solid #184687 !important;
}

.el-menu-item-indexs {
  line-height: 5 !important;
  font-size: 14px !important;
  height: 100% !important;
  margin-right: 50px !important;
}

.el-menu-item-index {
  line-height: 5 !important;
  margin-right: 30px !important;
  font-size: 14px !important;
  height: 100% !important;
}

.el-menu-item-index:hover {
  background-color: transparent !important;
}

.el-menu-item-indexs:hover {
  background-color: transparent !important;
}

.user-right:hover {
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: #ffffff;
}

.el-menu-index {
  padding: 13px;
  padding-bottom: 0;
  background: #f5f5f5;
}

.el-menu-other {
}

.el-menu.el-menu--horizontal {
  border-bottom: 0;
}

.user-right {
  font-size: 16px !important;
  float: right !important;
  padding: 0 0 0 0;
  max-width: 150px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.el-menu--horizontal > .el-menu-item.user-right.is-active {
  border-bottom: 3px solid #18468700 !important;
}

.el-menu--horizontal > .el-menu-item.submenuslogin.is-active {
  border-bottom: 3px solid #18468700 !important;
}

.submenuslogin {
  float: right !important;
  margin-top: 4px !important;
  margin-right: 40px;
}

.submenus {
  float: right !important;
  margin-top: 5.5px;
  margin-right: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.index-logo {
  width: 100px;
  height: 100px;
  background-image: image("../assets/logo.jpg");
}

.el-avatar {
  margin-left: 20px;
}

.el-header-index {
  border-bottom: #f5f5f5 1px solid;
  text-align: center;
  height: 86px !important;
  padding: 0;
  position: relative;
  width: 1200px;
  /* left: 50%;
   transform: translate(-50%, 0);*/

  .img {
    float: left;
    margin-top: 1%;
    height: 50px;
  }
}

.el-header-other {
  border-bottom: white 4px solid;
  width: 100%;
  text-align: center;
  height: 96px !important;
  margin-bottom: 12px;
  background-size: 100% 100%;
  padding: 0;

  .img {
    float: left;
    margin-top: 5%;
    width: 118px;
    height: 39px;
    margin-left: 14%;
  }
}

.footer {
  background-color: #184687;
  color: #ffffff;
  text-align: center;
  height: 140px !important;
  line-height: 1000%;
  float: left;
  width: 100%;
  font-size: 14px;
}

.el-mains {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  width: 100%;
  color: #333333;
  text-align: center;
  line-height: 50px;
  padding: 0;
  z-index: 1;
}
</style>
